import axios from "axios"
import ENV from "../config/env"

export const CREATE_USER = 'CREATE_USER'
export const FIND_ALL_USERS = 'FIND_ALL_USERS'
export const FIND_ONE_USER = 'FIND_ONE_USER'
export const DELETE_ONE_USER = 'DELETE_ONE_USER'
export const UPDATE_ONE_USER = 'UPDATE_ONE_USER'

const dispatchUser = (type, payload) => ({type: type, payload: payload})
const token = localStorage.getItem('token')

export const create = data => dispatch => {
    return axios.post(`${ENV.API}/user`, data, {headers: {'x-access-token': token}})
        .then(res => {
            console.log(res)
            if (res.data.errmsg) {
                alert(res.data.errmsg)
                dispatch(dispatchUser(CREATE_USER, false))
                return false
            } else {
                dispatch(dispatchUser(CREATE_USER, res.data))
                return true
            }
        })
        .catch(err => {
            console.log(err)
        })
}

export const findOneUser = (id) => dispatch => {
    return axios.get(`${ENV.API}/user/${id}`, {headers: {'x-access-token': token}})
        .then(res => {
            if (res.data.errmsg) {
                alert(res.data.errmsg)
                dispatch(dispatchUser(FIND_ONE_USER, false))
                return false
            } else {
                dispatch(dispatchUser(FIND_ONE_USER, res.data))
                return res.data
            }
        })
        .catch(err => {
            console.log(err)
        })
}

export const findAllUsers = () => dispatch => {
    return axios.get(`${ENV.API}/users`, {headers: {'x-access-token': token}})
        .then(res => {
            if (res.data.errmsg) {
                alert(res.data.errmsg)
                dispatch(dispatchUser(FIND_ALL_USERS, false))
                return false
            } else {
                dispatch(dispatchUser(FIND_ALL_USERS, res.data))
                return res.data
            }
        })
        .catch(err => {
            console.log(err)
        })
}

export const updateOneUser = data => dispatch => {
    return axios.put(`${ENV.API}/user/${data.idUser}`, data, {headers: {'x-access-token': token}})
        .then(res => {
            if (res.data.errmsg) {
                alert(res.data.errmsg)
                dispatch(dispatchUser(UPDATE_ONE_USER, false))
                return false
            } else {
                dispatch(dispatchUser(UPDATE_ONE_USER, res.data))
                return res.data
            }
        })
        .catch(err => {
            console.log(err)
        })
}

export const deleteOneUser = data => dispatch => {
    return axios.delete(`${ENV.API}/user/${data}`, {headers: {'x-access-token': token}})
        .then(res => {
            if (res.data.errmsg) {
                alert(res.data.errmsg)
                dispatch(dispatchUser(DELETE_ONE_USER, false))
                return false
            } else {
                dispatch(dispatchUser(DELETE_ONE_USER, res.data))
                return res.data
            }
        })
        .catch(err => {
            console.log(err)
        })
}
